import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';


const getClass = (reviewRating, starPosition) => {
  if (reviewRating - starPosition > -0.5) {
    return 'full';
  } else if (reviewRating - starPosition > -1) {
    return 'half';
  } else {
    return 'empty';
  }
};

const ReviewStars = ({reviews, showText}) => {
  reviews = reviews || {averageRating: 5};
  return (
    <div className="reviews-stars">
      <span className="stars has-reviews">
        <span className={classNames('star', getClass(reviews.averageRating, 1))}></span>
        <span className={classNames('star', getClass(reviews.averageRating, 2))}></span>
        <span className={classNames('star', getClass(reviews.averageRating, 3))}></span>
        <span className={classNames('star', getClass(reviews.averageRating, 4))}></span>
        <span className={classNames('star', getClass(reviews.averageRating, 5))}></span>
      </span>
      <span className="reviews-count">
        {reviews.totalReviews !== undefined && showText ? <span>({reviews.totalReviews} <FormattedMessage id="yotpo.reviews"/>)</span> : null }
        {reviews.totalReviews !== undefined && !showText ? <span>({reviews.totalReviews})</span> : null }
      </span>
    </div>
  );
};

ReviewStars.propTypes = {
  reviews: PropTypes.object,
  showText: PropTypes.bool
};

export default ReviewStars;



// WEBPACK FOOTER //
// ./components/Review-stars.js